export default "__VITE_ASSET__Bx_OxI0K__";